import axios from "axios";
import { API_BASE_URL } from "./common";
const VEHICLE_GET_DATA = `${API_BASE_URL}/vehicle/get-data`;
const VEHICLE_AVERAGE_TIME = `${API_BASE_URL}/vehicle/average-time`;
const VEHICLE_AVERAGE_TIME_V1 = `${API_BASE_URL}/vehicle/average-time-v1`;
const VEHICLE_START_PREP = `${API_BASE_URL}/vehicle/start-prep`;
const OFFSITE_GET_DATA = `${API_BASE_URL}/offsite/get-data`;
const VEHICLE_CHANGE_STATUS = `${API_BASE_URL}/vehicle/change-status`;
const VEHICLE_CHANGE_BODYSHOP_STATUS = `${API_BASE_URL}/vehicle/change-bodyshop-status`;
const VEHICLE_SOLD_UNSOLD = `${API_BASE_URL}/vehicle/mark-as-sold`;
const CHECKLIST_GET_DATA = `${API_BASE_URL}/vehicle/get-red-checklist`;

const GET_VHC_DETAIL = `${API_BASE_URL}/vehicle/get-vhc-detail`;
const UPLOAD_IMAGE = `${API_BASE_URL}/vehicle/upload-image`;

const VEHICLE_ADD_NOTE = `${API_BASE_URL}/vehicle/add-note`;
const VEHICLE_EDIT_NOTE = `${API_BASE_URL}/vehicle/edit-note`;
const VEHICLE_GET_NOTE = `${API_BASE_URL}/vehicle/get-note`;
const VEHICLE_GET_NOTE_VIEW = `${API_BASE_URL}/vehicle/get-swimlane-note`;
const VEHICLE_GET_NOTE_DETAIL = `${API_BASE_URL}/vehicle/edit-note-detail`;

const VEHICLE_OUTSIDE = `${API_BASE_URL}/vehicle/get-offsite-list`;

const GET_BY_MAKEDATA = `${API_BASE_URL}/vehicle/get-make`;
const LOCAION_GET_DATA = `${API_BASE_URL}/location/get-data`;
const DEALERSHIP_GET_DATA = `${API_BASE_URL}/dealership/get-dealership`;

const UPDATE_HEALTH_CHECKLIST = `${API_BASE_URL}/vehicle/update-health-checklist`;

// export const vehicleGetData = async ({
//   authToken,
//   location_id,
//   page = 1,
//   limit = 10,
//   search = "",
//   // vehicleNumber,
//   isSearchEnable = false,
//   isFilterByPrep = false,
//   nonce = false,
//   // sortBy = "createdAt",
//   // sortOrder = "DESC",
//   ...props
// }) => {
//   const response = await axios({
//     method: "POST",
//     data: {
//       auth: authToken,
//       location_id: location_id,
//       page,
//       limit,
//       // search,
//       // vehicle_number: vehicleNumber,
//       is_searchEnable: isSearchEnable,
//       // is_filter_by_prep: isFilterByPrep,
//       nonce: nonce,
//       ...props,
//       // sort_by: sortBy,
//       // sort_order: sortOrder,
//     },
//     url: VEHICLE_GET_DATA,
//     headers: { "Content-Type": "application/x-www-form-urlencoded" },
//   });
//   return response.data;
// };

export const vehicleGetData = async ({
  authToken,
  location_id,
  page = 1,
  limit = 10,
  search = "",
  vehicleNumber,
  isFilterByPrep = false,
  // isSearchEnable = false,
  // vehicle_sort,
  // nonce = false,
  // sort_up,
  station,
  sort_up = "DESC",
  isSearchEnable = 1,
  nonce = new Date().getTime(),
  vehicle_sort = true,
  // sortBy = "createdAt",
  // sortOrder = "DESC",
  ...props
}) => {
  // console.log("SSSSS vehicleGetData ~ api params:", { sort_up, props })
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      location_id: location_id,
      page,
      limit,
      nonce,
      ...(search ? { search } : {}),
      ...(vehicleNumber ? { vehicle_number: vehicleNumber } : {}),
      // ...(isSearchEnable ? { is_searchEnable: isSearchEnable } : {}),
      ...(isFilterByPrep ? { is_filter_by_prep: isFilterByPrep } : {}),
      // ...(vehicle_sort ? { vehicle_sort: vehicle_sort } : {}),
      ...(station ? { station: station } : {}),
      ...(sort_up ? { sort_up } : {}),
      vehicle_sort,
      // sort_up,
      is_searchEnable: isSearchEnable,
      ...props,
    },
    url: VEHICLE_GET_DATA,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const vehicleAverageTime = async ({ authToken, location_id }) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      location_id: location_id,
    },
    url: VEHICLE_AVERAGE_TIME,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const vehicleAverageTimeV1 = async ({ authToken, location_id }) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      location_id: location_id,
    },
    url: VEHICLE_AVERAGE_TIME_V1,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const offsiteGetData = async ({
  authToken,
  location_id,
  departmentType,
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      location_id: location_id,
      department_type: departmentType,
    },
    url: OFFSITE_GET_DATA,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const startPrep = async ({
  authToken,
  vehicleId,
  userCode,
  loginBy,
  userGuid,
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
      user_code: userCode,
      login_by: loginBy,
      user_guid: userGuid,
    },
    url: VEHICLE_START_PREP,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const changeStatus = async ({
  authToken,
  vehicleId,
  userCode,
  type,
  status,
  offsiteId,
  advertisingPhoto,
  advertisingWeb,
  isRequired,
  forceCompleteBodyshop,
  loginBy,
  note_type,
  note,
  userGuid,
  detail,
  isNoRequired: isNoRequired,
  vehicle_update_id,
}) => {
  console.log(
    "change Status api nik",
    authToken,
    vehicleId,
    userCode,
    type,
    status,
    offsiteId,
    advertisingPhoto,
    advertisingWeb,
    forceCompleteBodyshop,
    loginBy,
    userGuid,
    // "jjjj",
    isNoRequired
  );

  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
      user_code: userCode,
      type: type,
      status: status,
      offsite_id: offsiteId,
      advertising_photo: advertisingPhoto,
      advertising_web: advertisingWeb,
      is_required: isRequired,
      force_complete_bodyshop: forceCompleteBodyshop,
      login_by: loginBy,
      user_guid: userGuid,
      note_type: note_type,
      note: note,
      isNoRequired: isNoRequired,
      detail: detail,
      vehicle_update_id,
    },
    url: VEHICLE_CHANGE_STATUS,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const bodyshopChangeStatus = async ({
  authToken,
  vehicleId,
  userCode,
  type,
  status,
  offsiteId,
  advertisingPhoto,
  advertisingWeb,
  forceCompleteBodyshop,
  userGuid,
  loginBy,
  note_type,
  note,
  detail,
}) => {
  console.log(
    "change Status api nik",
    authToken,
    vehicleId,
    userCode,
    type,
    status,
    offsiteId,
    advertisingPhoto,
    advertisingWeb,
    forceCompleteBodyshop
  );

  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
      user_code: userCode,
      type: type,
      status: status,
      offsite_id: offsiteId,
      advertising_photo: advertisingPhoto,
      advertising_web: advertisingWeb,
      force_complete_bodyshop: forceCompleteBodyshop,
      login_by: loginBy,
      user_guid: userGuid,
      note_type: note_type,
      note: note,
      detail: detail,
    },
    url: VEHICLE_CHANGE_BODYSHOP_STATUS,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const vehicleSoldUnsold = async ({
  authToken,
  vehicleId,
  userCode,
  isSold,
  locationId,
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
      user_code: userCode,
      is_sold: isSold,
      location_id: locationId,
    },
    url: VEHICLE_SOLD_UNSOLD,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const vehicleAddNote = async ({
  authToken,
  vehicleId,
  userCode,
  note,
  department_type,
  vehicle_update_id,
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
      user_code: userCode,
      note: note,
      department_type: department_type,
      vehicle_update_id,
    },
    url: VEHICLE_ADD_NOTE,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const vehicleGetNote = async ({ authToken, vehicleId }) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
    },
    url: VEHICLE_GET_NOTE,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const vehicleGetNoteView = async ({
  authToken,
  vehicleId,
  department_type,
  note_type,
  vehicle_update_id,
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
      department_type,
      note_type,
      vehicle_update_id,
    },
    url: VEHICLE_GET_NOTE_VIEW,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const GetNoteData = async ({ note_id }) => {
  const response = await axios({
    method: "POST",
    data: { note_id: note_id },
    url: VEHICLE_GET_NOTE_DETAIL,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const locationGetData = async ({
  authToken,
  // location_id,
  nonce,
  loginBy,
  userGuid,
  dealership_id,
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      // location_id: location_id,
      nonce: nonce,
      login_by: loginBy,
      user_guid: userGuid,
      dealership_id,
    },
    url: LOCAION_GET_DATA,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const checklistGetData = async (vehicle_id) => {
  const response = await axios({
    method: "POST",
    data: {
      vehicle_id,
    },
    url: CHECKLIST_GET_DATA,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const dealershipGetData = async ({ authToken }) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
    },
    url: DEALERSHIP_GET_DATA,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const vehicleEditNote = async ({
  authToken,
  vehicleId,
  userCode,
  note,
  note_id,
  vehicle_update_id,
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
      user_code: userCode,
      note: note,
      note_id: note_id,
      vehicle_update_id,
    },
    url: VEHICLE_EDIT_NOTE,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const offsiteApi = async ({
  authToken,
  vehicleId,
  location_id,
  type,
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
      location_id,
      type: type,
    },
    url: VEHICLE_OUTSIDE,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const getByMakeData = async ({
  authToken,

  location_id,
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      location_id,
    },
    url: GET_BY_MAKEDATA,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const vehicleGetFilterData = async (data) => {
  const response = await axios({
    method: "POST",
    data: data,
    url: VEHICLE_GET_DATA,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const getVhcDetails = async ({ authToken, vehicleId }) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
    },
    url: GET_VHC_DETAIL,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const uploadImage = async (formData) => {
  const response = await axios({
    method: "POST",
    data: formData,
    url: UPLOAD_IMAGE,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const updateHealthChecklist = async ({
  authToken,
  vehicleId,
  userCode,
  checks,
  locationId,
}) => {
  const response = await axios({
    method: "POST",
    data: {
      auth: authToken,
      vehicle_id: vehicleId,
      user_code: userCode,
      location_id: locationId,
      checks: checks,
    },
    url: UPDATE_HEALTH_CHECKLIST,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};
